import React, { useState } from 'react';
import minerals from '../data/minerals';
import Icons from './Icons';

export default function Minerals() {
	const [filter, setFilter] = useState('Todos');
	const categories = ['Todos', 'Metales Preciosos', 'Metales Industriales', 'Minerales de Hierro', 'Minerales Críticos'];
	const filtered = filter === 'Todos' ? minerals : minerals.filter(m => m.category === filter);

	return (
		<section id="minerales" className="py-12 bg-slate-50">
			<div className="max-w-7xl mx-auto px-4">
				<h2 className="text-3xl font-bold mb-6">Minerales Disponibles</h2>
				<div className="flex gap-2 mb-6">
					{categories.map(c => (
						<button key={c} onClick={() => setFilter(c)} className={`px-3 py-1 rounded-full ${filter===c? 'bg-mineral-600 text-white':'bg-white'}`}>{c}</button>
					))}
				</div>

				<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
					{filtered.map(m => (
						<div key={m.id} className="bg-white rounded-lg p-4 border">
							<img src={m.image} alt={m.name} className="w-full h-36 object-cover rounded-md mb-3" />
							<h3 className="font-bold">{m.name}</h3>
							<p className="text-sm text-slate-600">{m.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
